import { ToolbarFieldConfig } from "../../sinister/components/ToolbarSinisterGeneric/ToolbarSinisterGeneric";
import { AGREEMENT_STATUS_OPTIONS } from "../constants/agreementStatusOptions";
import { PAYMENT_METHOD_OPTIONS } from "../../creditRecovery/constants/paymentMethodOptions";

export const fieldsConfig: ToolbarFieldConfig[] = [
	{
		key: "status",
		label: "Status do Acordo",
		type: "select",
		options: [{ value: "Todos", label: "Todos" }, ...AGREEMENT_STATUS_OPTIONS],
		defaultValue: ["Todos"],
		extraProps: {
			multiple: true,
			sx: { minWidth: 200 },
			renderValue: (selected: string[]) => {
				const labelMap: Record<string, string> = { Todos: "Todos" };
				AGREEMENT_STATUS_OPTIONS.forEach((option) => (labelMap[option.value] = option.label));
				return selected.map((s) => labelMap[s] || s).join(", ");
			},
		},
		group: "status",
	},
	{
		key: "paymentMethod",
		label: "Forma de pagamento",
		type: "select",
		options: [{ value: "Todos", label: "Todos" }, ...PAYMENT_METHOD_OPTIONS],
		defaultValue: "Todos",
		extraProps: { sx: { minWidth: 180 } },
	},
	{
		key: "data",
		label: "Data",
		type: "select",
		options: [
			{ value: "hoje", label: "Hoje" },
			{ value: "anterior", label: "Anterior" },
			{ value: "7", label: "Últimos 7 dias" },
			{ value: "15", label: "Últimos 15 dias" },
			{ value: "30", label: "Últimos 30 dias" },
			{ value: "60", label: "Últimos 60 dias" },
			{ value: "90", label: "Últimos 90 dias" },
			{ value: "ano", label: "Ano Atual" },
			{ value: "mes", label: "Mês Atual" },
			{ value: "periodo", label: "Período", extraProps: { sx: { color: "#a268e4" } } },
		],
		defaultValue: "ano",
		extraProps: { sx: { minWidth: 150 }, size: "small" },
	},
	{
		key: "dataIni",
		label: "Data Inicial",
		type: "date",
		show: (filters) => filters.data === "periodo",
		extraProps: { sx: { minWidth: 150 } },
	},
	{
		key: "dataFim",
		label: "Data Final",
		type: "date",
		show: (filters) => filters.data === "periodo",
		extraProps: { sx: { minWidth: 150 } },
	},
	{
		key: "filterField",
		label: "Pesquisar por",
		type: "select",
		options: [
			{ value: "documento", label: "Documento" },
			{ value: "nome", label: "Nome" },
		],
		defaultValue: "documento",
		extraProps: { sx: { minWidth: 150 } },
		group: "searchBar",
	},
	{
		key: "textSearch",
		label: "Pesquisar",
		type: "text",
		extraProps: {
			placeholder: "Digite para buscar...",
			sx: { minWidth: 350 },
		},
		group: "searchBar",
	},
];
